module.exports = __webpack_public_path__ + "static/media/advantage_1.d7ce093d.png";